import { render, staticRenderFns } from "./InnerLayout.vue?vue&type=template&id=bd38bfe4&scoped=true&"
import script from "./InnerLayout.vue?vue&type=script&lang=js&"
export * from "./InnerLayout.vue?vue&type=script&lang=js&"
import style0 from "./InnerLayout.vue?vue&type=style&index=0&id=bd38bfe4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd38bfe4",
  null
  
)

export default component.exports